// extracted by mini-css-extract-plugin
export default {"grid-ul":"GroupsGrid_grid-ul__8Yof-","grid-li":"GroupsGrid_grid-li__AnmS4"};